import { render, staticRenderFns } from "./TestimCard.vue?vue&type=template&id=31effd32&scoped=true&"
import script from "./TestimCard.vue?vue&type=script&lang=js&"
export * from "./TestimCard.vue?vue&type=script&lang=js&"
import style0 from "./TestimCard.vue?vue&type=style&index=0&id=31effd32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31effd32",
  null
  
)

export default component.exports